import axiosInstance from '../utils/AxiosConfig';

// Menú mock para desarrollo cuando falla la conexión
const mockMenu = [
  {
    id: 1,
    name: 'Dashboard',
    path: '/dashboard',
    icon: 'dashboard'
  },
  {
    id: 2,
    name: 'Ventas',
    path: '/location/sales',
    icon: 'sales'
  },
  {
    id: 3,
    name: 'Productos',
    path: '/location/products',
    icon: 'products'
  },
  {
    id: 4,
    name: 'Clientes',
    path: '/clients',
    icon: 'clients'
  },
  {
    id: 5,
    name: 'Reportes',
    path: '/reports',
    icon: 'reports'
  }
];

export const getMenu = async () => {
  try {
    const response = await axiosInstance.get('/menu');
    const menuData = response.data.data;
    return menuData;
  } catch (error) {
    console.error('Error fetching menu:', error);
    // En caso de error, usar menú mock para desarrollo
    console.log('Using mock menu for development');
    return mockMenu;
  }
};


